import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useMemo} from 'react'

import {BlameBanners} from '../components/blob/Banners/BlameBanners'
import {BlobViewContent} from '../components/BlobViewContent'
import {BlobBanners} from '../components/CodeViewBanners'
import {useCodeNav} from '../contexts/CodeNavContext'
import {ContributorsProvider} from '../contexts/ContributorsContext'
import {useTreePaneContext} from '../contexts/TreePaneContext'
import {CurrentBlameProvider} from '../hooks/CurrentBlame'
import {useCurrentBlob} from '../hooks/CurrentBlob'
import {codeViewBlameRoute} from '../routes/code-view-blame-route'
import {codeViewBlobLayoutRoute} from '../routes/code-view-blob-layout-route'
import {codeViewLayoutRoute} from '../routes/code-view-layout-route'
import {CodeView} from './CodeView'

export function CodeViewBlameEntrypoint() {
  const {data: payload} = useRouteQuery(codeViewBlameRoute, 'mainQuery')
  const {data: layoutPayload} = useRouteQuery(codeViewLayoutRoute, 'mainQuery')
  const {data: blobLayoutPayload} = useRouteQuery(codeViewBlobLayoutRoute, 'mainQuery')
  const {
    data: contributorsData,
    error: contributorsError,
    isLoading: contributorsLoading,
  } = useRouteQuery(codeViewBlameRoute, 'contributors')

  const {isTreeExpanded, treeToggleElement} = useTreePaneContext()
  const {validCodeNav, setValidCodeNav} = useCodeNav()
  const blob = useCurrentBlob()

  const mergedPayload = useMemo(
    () => ({
      ...blobLayoutPayload,
      ...payload,
    }),
    [blobLayoutPayload, payload],
  )

  return (
    <CurrentBlameProvider blame={payload.blame}>
      <ContributorsProvider contributors={contributorsData} error={contributorsError} loading={contributorsLoading}>
        <CodeView payload={mergedPayload} action="blame" isBlame>
          {() => (
            <>
              {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
              <div className="react-code-view-bottom-padding">
                <BlobBanners />
                <BlameBanners />
              </div>
              <BlobViewContent
                blame={payload.blame}
                blob={blob}
                symbolsExpanded={layoutPayload.symbolsExpanded}
                setValidCodeNav={setValidCodeNav}
                showTree={isTreeExpanded}
                treeToggleElement={treeToggleElement}
                validCodeNav={validCodeNav}
                copilotInfo={blobLayoutPayload.copilotInfo}
              />
            </>
          )}
        </CodeView>
      </ContributorsProvider>
    </CurrentBlameProvider>
  )
}
